var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Machining Products",
      "tabActive": "Metal",
      "bg": "/images/sub/visual/sv2.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit mb-lg-42"
  }, [_vm._v(" Metal ")])]), _c('sub-bg-image', {
    attrs: {
      "src": "/images/sub/products/metal/metal-top-img.png",
      "className": "h-lg-300px"
    }
  }, [_c('h3', {
    staticClass: "tit font-weight-semibold mb-8 mb-md-50 mb-lg-84"
  }, [_vm._v(" Various precision metal processing products used in the semiconductor industry ")]), _c('p', {
    staticClass: "min-w-80px min-w-lg-120px text-center color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v(" Representative Material ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51 mb-12 mb-lg-24"
  }, [_vm._v(" SUS304, SUS316, Al5083, Al6061 etc.. ")]), _c('p', {
    staticClass: "min-w-80px min-w-lg-120px text-center color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14",
    staticStyle: {
      "width": "fit-content"
    }
  }, [_vm._v(" Representative Product ")]), _c('p', {
    staticClass: "font-size-14 font-size-lg-16 color-grey-51"
  }, [_vm._v(" Retainer Ring, Metal Shank for Wafer Back Grinding Wheel, Precision Parts for Semiconductors, etc.. ")])])], 1), _vm.boards ? _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('slide-primary', _vm._l(_vm.boards, function (board) {
    return _c('div', {
      key: board._id,
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "pb-16 pb-lg-30 border-bottom"
    }, [_c('div', {
      staticClass: "thum-wrap"
    }, [_c('div', {
      staticClass: "thum",
      style: "background-image: url(".concat(board.thumb, ")")
    })])])]);
  }), 0)], 1)], 1) : _vm._e(), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('inquiry', {
    attrs: {
      "src": "/images/sub/distributor/dupont/dupont-img1.png",
      "name": "Yoo Dong, Jang",
      "tel": "+82-31-765-2268",
      "mail": "ydjang@ist-co.kr",
      "fax": "82-31-765-2389"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }